import { render, staticRenderFns } from "./collapsible.vue?vue&type=template&id=2ac2e370&scoped=true&"
import script from "./collapsible.vue?vue&type=script&lang=js&"
export * from "./collapsible.vue?vue&type=script&lang=js&"
import style0 from "./collapsible.vue?vue&type=style&index=0&id=2ac2e370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2e370",
  null
  
)

export default component.exports